import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './Breadcrumb.css';

const Breadcrumb = (props) => {
  const { match, location } = props;
  const linkText = {
    about: '關於我們',
    locations: '銷售據點',
    register: '產品登錄',
    news: '最新消息',
    contact: '聯絡我們',
    search: '搜尋結果',
  };
  return (
    <div className="breadcrumb-wrapper">
      <nav className="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <Link to="/">首頁</Link>
          </li>
          <li className="is-active">
            <Link to={match.url} aria-current="page">
              {linkText[location.pathname.split('/')[1]]}
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

Breadcrumb.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.object,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

Breadcrumb.defaultProps = {
  match: {
    params: {},
  },
  location: {
    pathname: '/',
  },
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/components/Breadcrumb.js